<template>
  <div class="wrapBox" style=" padding-left:4px;padding-right:8px;padding-top:8px;">
    <div id="myTradeTermYears" :style="{width: '100%', height: '250px'}"> 
    </div>
  </div>
</template>



<script>
export default {
  name: 'LastYearInOutTrade',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      titleText: '历年贸易方式分析',
      textStyle: {color:'#ccc', fontStyle:'normal', fontWeight:'bold', fontFamily:'sans-serif', fontSize:12 },
      legendPadding: [65, 5, 15, 5],
      legendData: ['海运','空运','邮递','其他']
    }
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myTradeTermYears = this.$echarts.init(document.getElementById('myTradeTermYears'), 'chalk')
        myTradeTermYears.setOption(
            {
                title: {
        text: this.titleText,
        left: 'left',
        textStyle:this.textStyle},
                

    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            crossStyle: {
                color: '#999'
            }
        }
    },
    toolbox: {
        feature: {
            //dataView: {show: true, readOnly: false},
            //magicType: {show: true, type: ['line', 'bar']},
            //restore: {show: true},
            //saveAsImage: {show: true}
        }
    },
    legend: {
        data:['进口额','进口额2','人民币环比'],
        padding: [25, 10, 15, 20], 
    },
    xAxis: [
        {
            type: 'category',
            data: ['2012','2013','2014','2015','2016','2017'],
            axisPointer: {
                type: 'shadow'
            },
            axisLabel:{
            show:true,
            interval:'0',
            rotate:60 
            }
        }
    ],
    yAxis: [
        {
            type: 'value',
            name: '进口额（亿）',
            min: 1000,
            max: 9000,
            interval: 1000,
            axisLabel: {
                formatter: '{value}'
            }
        }
    ],
    series: [
        {
            name:'进口额',
            type:'line',
            yAxisIndex: 0,
            data:[3254 ,3383 ,3668 ,3460 ,3835 ,4549 ]
        },
        {
            name:'进口额2',
            type:'line',
            yAxisIndex: 0,
            data:[1254 ,2383 ,2668 ,5460 ,5835 ,9549]
        }
    ]
});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TradeTermYears.vue